export default "__VITE_ASSET__DabljQ26__"